import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'cancel', 'Cancel', [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"}],["path",{"d":"M18.364 5.636l-12.728 12.728"}]]);